const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

import level from '@/components/papr/level/router'
import version from '@/components/papr/version/router'
import indexing from '@/components/papr/indexing/router'
import journal from '@/components/papr/journal/router'
import rept from '@/components/papr/rept/router'

export default {
  routes: [
    {
      path: '/papr/index',
      name: 'papr_index',
      component: Index
    },
    {
      path: '/papr/personal',
      name: 'papr_personal',
      component: Personal
    }
  ].concat(
    ...level.routes,
    ...version.routes,
    ...indexing.routes,
    ...journal.routes,
    ...rept.routes
  )
}
